<template>
  <b-card
    bg-variant="light"
    class="my-2">
    <b-form-group
      :label="label"
      :disabled="disabled"
      label-cols-sm="3"
      class="mb-0">
      <b-form-group>
        <b-radio-group
          v-model="image.isRemote"
          @change="onIsRemoteChanged">
          <b-form-radio :value="false">
            Bundled Asset
          </b-form-radio>
          <b-form-radio :value="true">
            Remote URL
          </b-form-radio>
        </b-radio-group>
        <template
          v-if="image.isRemote"
          v-slot:description>
          Use a remote image asset
        </template>
        <template
          v-else
          v-slot:description>
          Reference a bundled asset within the application
        </template>
      </b-form-group>
      <template v-if="image.isRemote">
        <b-form-row>
          <b-col>
            <b-form-group
              label="Image URL"
              invalid-feedback="Value must be a valid URL">
              <b-input-group>
                <b-form-input
                  v-model="image.location"
                  type="url"
                  :required="!disabled" />
                <b-input-group-append>
                  <b-btn
                    variant="outline-primary"
                    @click.prevent="$refs.assetUploadModal.show()">
                    <i class="fas fa-plus" />
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col
            v-if="showPreview"
            md="3">
            <b-img
              :src="image.location"
              alt=""
              thumbnail
              fluid
              center />
          </b-col>
        </b-form-row>
      </template>
      <b-form-group
        v-else
        label="Resource Identifier"
        invalid-feedback="Resource identifier is required">
        <b-form-input
          v-model="image.location"
          :required="!disabled" />
      </b-form-group>
    </b-form-group>
    <b-modal
      id="asset-upload"
      ref="assetUploadModal"
      hide-header
      hide-footer
      size="lg">
      <asset-upload
        post-action="/api/configuration/v1/webview/assets"
        @asset-url-selected="onAssetSelect"
        @cancel="$refs.assetUploadModal.hide()" />
    </b-modal>
  </b-card>
</template>

<script>
  import AssetUpload from "@/components/AssetUpload"

  export default {
    name: "WebViewImageSelection",
    components: {
      AssetUpload,
    },
    props: {
      value: {
        type: Object,
        default: () => ({
          isRemote: false,
          location: null,
        }),
      },
      label: {
        type: String,
        default: "Image",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      cachedLocation: null,
    }),
    computed: {
      image: {
        get: function () {
          return this.value
        },
        set: function (value) {
          this.$emit("input", value)
        },
      },
      showPreview() {
        return this.image.isRemote
          && this.image.location
          && /.(jpg|jpeg|png|gif)$/i.test(this.image.location)
      },
    },
    methods: {
      onAssetSelect(url) {
        this.$refs.assetUploadModal.hide()
        if (url) {
          this.image.location = url
        }
      },
      onIsRemoteChanged() {
        const newCachedLocation = this.image.location
        this.image.location = this.cachedLocation
        this.cachedLocation = newCachedLocation
      },
    },
  }
</script>

<style scoped>

</style>
